import { Card, ComponentState, Group, Number, Skeleton, Spinner, Text, Tooltip } from "components/common"
import { StatsHeading } from ".."
import styles from "./index.module.less"
import { t } from "i18next"
import { useSelector } from "react-redux"

export default function FunnelChart(props) {
  const { queryObj, title, type, load, useQuery } = props
  const { rtl } = useSelector(state => state.app.configs)
  const defaultBackgroundColor = ["#8fa2c6", "#7c99ab", "#75c9a2", "#509f8f", "#1c6758"]
  let updatedQueryObj = { ...queryObj, load }
  const {
    data: response,
    isFetching,
    error,
    refetch,
  } = useQuery(updatedQueryObj, {
    refetchOnMountOrArgChange: true,
  })
  const { clients, funnel: data } = response || {}

  const leadCategoryDescription = () => {
    return {
      inquiry: t("New Client / No meaningful working in last 90 days"),
      prospect: t("Client has been contacted in past 90 days"),
      mature: t("Meeting done in last 60 days"),
      pre_closure: t("Active Token or Partial Down Payment (PDP) in the system"),
      sold: t("Complete Down Payment (CDP) has been made by the client"),
    }
  }

  const SvgFunnelItem = props => (
    <svg width={0} height={0} viewBox="0 0 277 54" {...props}>
      <defs>
        <clipPath id="funnel-bg" clipPathUnits="objectBoundingBox">
          <path d="m1,0,-0.086,0.881 a0.003,0.015,0,0,1,0,0.002 l0,0.001 h0 c-0.01,0.064,-0.191,0.116,-0.413,0.116 c-0.224,0,-0.407,-0.052,-0.414,-0.117 h0 L0,0 c0.012,0.064,0.231,0.115,0.5,0.115 c0.269,0,0.488,-0.051,0.5,-0.115" />
        </clipPath>
      </defs>
    </svg>
  )

  const onClickItem = path => {
    window.open(window.location.origin + path, "_blank")
  }

  const renderLoadingFunnel = () => {
    const funnelDivisors = [1, 1.25, 1.54, 1.91]
    const stripeBaseWidth = 260
    return (
      <div style={{ marginTop: "15px" }}>
        {[0, 1, 2, 3].map(index => (
          <div
            key={index}
            className={`${styles.funnelStripe} ${index === 0 ? styles.funnelHead : ""}`}
            style={{
              "--stripe-color": "#f0f2f5",
              "--stripe-width": `${stripeBaseWidth / funnelDivisors[index]}px`,
              height: "54px",
              maxWidth: "260px",
              margin: "0 auto",
            }}
          >
            <Skeleton
              type="input"
              width="100%"
              height={36}
              style={{
                background: "#f0f2f5",
                borderRadius: 0,
                border: "none",
              }}
            />
          </div>
        ))}
      </div>
    )
  }

  const renderFunnelBar = (
    { label, key, percentage, count, potentialRevenue, redirectRoute, backgroundColor },
    index
  ) => {
    const funnelStrip = () => {
      return (
        <Tooltip title={leadCategoryDescription()[key]} placement={rtl ? "topRight" : "topLeft"}>
          <div
            className={styles.funnelStripe}
            style={{ "--stripe-color": backgroundColor ? backgroundColor : defaultBackgroundColor[index] }}
            onClick={() => redirectRoute && onClickItem(redirectRoute)}
          >
            <Number value={percentage} isStringOnly wrapValue={v => `${v} %`} defaultValue="" />
            <div>
              <Number value={count} color="#fff" /> {type ? type : key}
            </div>
          </div>
        </Tooltip>
      )
    }
    return (
      <Group className={styles.funnelItem} template="50px 280px 90px" style={{ width: "100%" }} key={index}>
        <div>{label}</div>
        {index === 0 ? <span className={styles.funnelHead}>{funnelStrip()}</span> : funnelStrip()}
        {/* {potentialRevenue && (
          <div className={styles.expandedDetail}>
            <span>
              <Text style={{ fontSize: "10px" }} type="secondary">
                {t("Potential Revenue")}
              </Text>
              <div style={{ fontWeight: 600 }}>
                <Number value={potentialRevenue} tooltip isCurrency tooltipPlacement="left" />
              </div>
            </span>
          </div>
        )} */}
      </Group>
    )
  }

  return !!error ? (
    <Card>
      <ComponentState
        description={error?.message}
        status={error?.status}
        btnLoading={isFetching}
        onClick={() => refetch()}
      />
    </Card>
  ) : (
    <>
      <Card
        title={
          isFetching ? (
            <Skeleton />
          ) : clients?.totalClients ? (
            <StatsHeading title={title} value={clients?.totalClients} />
          ) : (
            <Text className={styles.statsTitle}>{title}</Text>
          )
        }
        extra={
          isFetching ? (
            <Skeleton />
          ) : (
            data?.extra && (
              <StatsHeading
                title={data?.extra?.title}
                value={data?.extra?.count}
                percentage={<Number value={data?.extra?.percentage} isStringOnly wrapValue={v => `(${v} %)`} />}
                type="extra"
              />
            )
          )
        }
        headStyle={{ borderBottom: 0 }}
      >
        <SvgFunnelItem />
        {isFetching ? (
          <>
            <>{renderLoadingFunnel()}</>
          </>
        ) : (
          <Group gap="0px" template="initial">
            {data?.list.map(renderFunnelBar)}
          </Group>
        )}
      </Card>
    </>
  )
}
